import axiosInstance from "../../Utils/axiosInstance";
import { getLoggedInUserGroup } from "../../Utils/Constant";

export const getCURFQAssignedToMeFilterMetaFieldsApi = async () => {
    try {
        const groups = getLoggedInUserGroup(); // e.g. ["North America", "Domestic & Europe"]

        const queryString = groups
            .map((g) => `group=${encodeURIComponent(g)}`)
            .join("&");

        const response = await axiosInstance.get(
            `api/sourcing_management/getCURFQAssignedToMeFilterMetaFields?${queryString}`
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

// Interface
interface UploadRfqPartFilePayload {
    rfqPartId: string;
    fileUpload: File;
}

export interface DeleteDrawingPayload {
    CORFQ_Part_ID: string;
    File_Name: string;
}

export interface ApiResponse {
    success?: boolean;
    message?: string;
    [key: string]: any; // optional extra fields
}

export const uploadRfqPartFileAPI = async (
    payload: UploadRfqPartFilePayload
) => {
    try {
        const formData = new FormData();
        formData.append("recordId", payload.rfqPartId);
        formData.append("uploadField", "Upload_Step_File");
        formData.append("fileUpload", payload.fileUpload);

        const response = await axiosInstance.post(
            "api/key_account_management/saveFile",
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );
        console.log("uploadapires", response.status);

        if (!response?.data || response.status !== 202) {
            return { saveFileResponse: response?.data, autodeskResponse: null };
        }

        // (async () => {
        try {
            const autodeskFormData = new FormData();
            autodeskFormData.append("file", payload.fileUpload);
            autodeskFormData.append("rfqPartId", payload.rfqPartId);

            const autodeskResponse = await axiosInstance.post(
                "api/fileViewerRoute/autodesk/upload",
                autodeskFormData,
                {
                    headers: { "Content-Type": "multipart/form-data" }
                }
            );

            console.log("Autodesk API response:", autodeskResponse.data);
        } catch (err) {
            console.error("Autodesk upload failed:", err);
        }
        // })();

        return {
            saveFileResponse: response?.data,
            autodeskResponse: "processing"
        };
    } catch (error: any) {
        return error?.response?.data;
    }
};

// // API Call
// export const uploadRfqPartFileAPI = async (
//   payload: UploadRfqPartFilePayload
// ) => {
//   try {
//     const formData = new FormData();
//     formData.append("recordId", payload.recordId);
//     formData.append("uploadField", "Upload_Step_File");
//     formData.append("fileUpload", payload.fileUpload);

//     const response = await axiosInstance.post(
//       "api/key_account_management/saveFile",
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data", // Axios requires you to set this manually sometimes
//         },
//       }
//     );

//     return response?.data;
//   } catch (error: any) {
//     return error?.response?.data;
//   }
// };

export const getDrawingStepFileDownload = async (
    payload: string,
    filename: string
) => {
    try {
        const response = await axiosInstance.get(
            `api/general/getDrawingAndStepFiles?Company_RFQ_ID=${payload}`,
            { responseType: "blob" }
        );

        // Create a blob URL
        const blob = new Blob([response.data], {
            type: response.headers["content-type"]
        });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition = response.headers["content-disposition"];
        let fileName = filename;
        console.log("filename", fileName);
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
                fileName = match[1];
            }
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true; // Indicate successful download
    } catch (error) {
        console.error("Error fetching files:", error);
        return error?.response?.data;
    }
};

export const uploadDrawingApi = async (partID: string, files: File[]) => {
    try {
        const formData = new FormData();

        files.forEach((file) => formData.append("file", file));

        formData.append("CORFQ_Part_ID", partID);

        const response = await axiosInstance.post(
            `/api/file_handling/addAdditionalDrawingFiles`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    } catch (error: any) {
        console.error(
            "Error uploading drawing:",
            error?.response?.data || error
        );
        throw error?.response?.data || error;
    }
};

export const DeleteDrawingApi = async (
    payload: DeleteDrawingPayload
): Promise<ApiResponse> => {
    try {
        const response = await axiosInstance.post(
            "api/file_handling/deleteAdditionalDrawingFiles",
            payload
        );
        return response.data;
    } catch (error: any) {
        return (
            error?.response?.data || { success: false, message: "API Error" }
        );
    }
};
